/** Default oral-exam question scripts + avatar timing (questions.mp4). */
export const EXAM_SIMULATOR_MAX_QUESTIONS_PER_SLIDE = 4;

export const EXAM_SIMULATOR_QUESTION_TEMPLATES = [
  {
    question_index: 1,
    sort_order: 1,
    question_text: "What is this tissue?",
    video_start_sec: 0,
    video_end_sec: 2,
    wait_start_sec: 3,
    wait_end_sec: 5,
    slide_video_end_sec: null,
  },
  {
    question_index: 2,
    sort_order: 2,
    question_text: "Which features helped you identify it?",
    video_start_sec: 6,
    video_end_sec: 8,
    wait_start_sec: 9,
    wait_end_sec: 11,
    slide_video_end_sec: null,
  },
  {
    question_index: 3,
    sort_order: 3,
    question_text: "What structures can you clearly identify?",
    video_start_sec: 11,
    video_end_sec: 14,
    wait_start_sec: 15,
    wait_end_sec: 17,
    slide_video_end_sec: null,
  },
  {
    question_index: 4,
    sort_order: 4,
    question_text: "Can you describe the marked area?",
    video_start_sec: 17,
    video_end_sec: 21,
    wait_start_sec: 21,
    wait_end_sec: 24,
    slide_video_end_sec: 23,
  },
];

export function getQuestionTemplate(index) {
  const idx = Math.min(
    EXAM_SIMULATOR_MAX_QUESTIONS_PER_SLIDE,
    Math.max(1, Number(index) || 1),
  );
  return (
    EXAM_SIMULATOR_QUESTION_TEMPLATES.find((t) => t.question_index === idx) ||
    EXAM_SIMULATOR_QUESTION_TEMPLATES[0]
  );
}

export function countQuestionsForSlide(items, slideId, category) {
  return items.filter(
    (q) => q.slide_id === slideId && q.category === category,
  ).length;
}

export function nextQuestionIndexForSlide(items, slideId, category) {
  return countQuestionsForSlide(items, slideId, category) + 1;
}

export function buildNewQuestionForm({ category, slideId, items }) {
  const nextIndex = nextQuestionIndexForSlide(items, slideId, category);
  if (nextIndex > EXAM_SIMULATOR_MAX_QUESTIONS_PER_SLIDE) {
    return null;
  }
  const template = getQuestionTemplate(nextIndex);
  return {
    id: null,
    category,
    slide_id: slideId,
    question_index: template.question_index,
    sort_order: template.sort_order,
    question_text: template.question_text,
    expected_answer: "",
    video_start_sec: template.video_start_sec,
    video_end_sec: template.video_end_sec,
    wait_start_sec: template.wait_start_sec,
    wait_end_sec: template.wait_end_sec,
    slide_video_end_sec: template.slide_video_end_sec ?? "",
    marker_location: null,
    is_active: true,
  };
}
